import React from "react";
import { Modal } from "react-bootstrap";
import DeleteIcon from "../../../assets/images/delete-icon-border.svg";
import ErrorIcon from "../../../assets/images/error.svg";
import SuccessIcon from "../../../assets/images/success.svg";
import "./styles.scss";

const CustomDialog = ({ 
  show, 
  onClose, 
  onConfirm,
  title = "Confirmar ação",
  description,
  buttons = [],
  icon,
  iconType = "danger", 
  dangerText = null 
}) => {
  const getDefaultIcon = () => {
    switch (iconType) {
      case "danger":
        return DeleteIcon;
      case "warning":
        return ErrorIcon;
      case "info":
        return SuccessIcon;
      default:
        return DeleteIcon;
    }
  };

  const renderIcon = () => {
    if (icon) {
      if (typeof icon === "string") {
        return <img src={icon} alt="dialog-icon" />;
      }
      return icon;
    }
    
    const defaultIcon = getDefaultIcon();
    if (typeof defaultIcon === "string") {
      return <img src={defaultIcon} alt="dialog-icon" />;
    }
    return defaultIcon;
  };

  const defaultButtons = [
    {
      label: "Cancelar",
      onClick: onClose,
      variant: "cancel"
    },
    ...buttons
  ];

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      className="dialog-modal"
    >
      <Modal.Body className="p-0">
        <div className="dialog-container">
          <div className="dialog-icon">
            {renderIcon()}
          </div>
          <div className="dialog-content">
            <h3 className="dialog-title">{title}</h3>
            <div className="dialog-message">
              {description && (
                <div dangerouslySetInnerHTML={{ __html: description }} />
              )}
              {dangerText && (
                <div className="danger-text">{dangerText}</div>
              )}
            </div>
          </div>
          <div className="dialog-actions">
            {defaultButtons.map((button, index) => (
              <button
                key={index}
                onClick={button.onClick || onConfirm}
                className={`btn-${button.variant || 'confirm'} ${button.className}` }
                style={button.style || {}}
                disabled={button.disabled}
              >
                {button.label}
              </button>
            ))}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CustomDialog;
